export const formatDuration = (totalSeconds) => {
  if (totalSeconds == null || !Number.isFinite(totalSeconds)) return '—';
  const total = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  return [hours, minutes, seconds].map((v) => String(v).padStart(2, '0')).join(':');
};
